<div class="formula-editor-section">
    <app-formula-expressao-editor
        [expressao]="expressao"
        [variaveis]="variaveis"
        (expressaoChange)="onExpressaoChange($event)">
    </app-formula-expressao-editor>

    @if (expressaoInvalida) {
    <app-alert-card type="error" title="Expressão inconsistente" icon="error">
        A expressão está inconsistente. Verifique os elementos destacados acima.
    </app-alert-card>
    }

    <section class="sub-section-container editor-subsection">
        <div class="sub-section-title">
            <mat-icon>data_object</mat-icon>
            <span>Variáveis</span>
            @if (variaveis.length > 0) {
            <button mat-button type="button" class="btn-section ms-auto" (click)="showAllVariaveis = !showAllVariaveis">
                <mat-icon>{{ showAllVariaveis ? 'expand_less' : 'expand_more' }}</mat-icon>
                {{ showAllVariaveis ? 'Ocultar' : 'Exibir todas as variáveis' }}
            </button>
            }
        </div>

        <div class="chips-row">
            <button type="button" class="status-badge chip-button chip-const" [ngClass]="badgeClasses.constante"
                title="Inserir constante numérica"
                (click)="inserirConstante()">
                <mat-icon>tag</mat-icon>
                Constante numérica
            </button>

            @for (variavel of variaveisAcessoRapido; track variavelChave(variavel)) {
            <button
                type="button"
                class="status-badge badge-variavel chip-button"
                [ngClass]="classeVariavel(variavel)"
                [title]="(variavel.observacao ?? variavel.descricao) + '\nChave: ' + variavel.chave + (variavel.pathTagXml ? '\nPath XML: ' + variavel.pathTagXml : '')"
                (click)="inserirVariavel(variavel)"
                [attr.data-chave]="variavelChave(variavel)">
                @if (isVariavelParametro(variavel)) {
                <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span>
                }
                @if (variavel.possuiFormulaAplicavel) {
                <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span>
                }
                <span class="variavel-badge-descricao">{{ variavel.descricao }}</span>
                <code class="variavel-badge-nome">{{ '{' + variavel.nome + '}' }}</code>
            </button>
            }
        </div>

        @if (showAllVariaveis && variaveis.length > 0) {
        <app-variaveis-disponiveis-section
            [variaveis]="variaveis"
            (variavelSelecionada)="inserirVariavel($event)">
        </app-variaveis-disponiveis-section>
        }
    </section>

    <section class="sub-section-container editor-subsection">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">calculate</mat-icon>
            <span>Operadores</span>
            <button mat-button type="button" class="btn-section ms-auto"
                (click)="showAllOperadores = !showAllOperadores">
                <mat-icon>{{ showAllOperadores ? 'expand_less' : 'expand_more' }}</mat-icon>
                {{ showAllOperadores ? 'Ocultar' : 'Exibir todos operadores' }}
            </button>
        </div>
        
        <div class="chips-row">
            @for (operador of operadoresAritmeticos; track operador.valor) {
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeTokenFormula(operador)"
                [matTooltip]="tooltipOperador(operador)" (click)="inserirToken(operador)">
                {{ operador.display }}
            </button>
            }

            @for (operador of operadoresAgrupamento; track operador.valor) {
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeTokenFormula(operador)"
                [matTooltip]="tooltipOperador(operador)" (click)="inserirToken(operador)">
                {{ operador.display }}
            </button>
            }

            <button type="button" class="status-badge chip-button"
                [ngClass]="badgeClasses.operadorAgrupamento"
                matTooltip="Insere par de parênteses"
                aria-label="Insere par de parênteses"
                (click)="inserirParentesesAgrupamento()">
                (&nbsp;&nbsp;)
            </button>
        </div>

        @if (showAllOperadores) {
        <div class="chips-row">
            @for (operador of operadoresComparacao; track operador.valor) {
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeTokenFormula(operador)"
                [matTooltip]="tooltipOperador(operador)" (click)="inserirToken(operador)">
                {{ operador.display }}
            </button>
            }

            @for (operador of operadoresLogicos; track operador.valor) {
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeTokenFormula(operador)"
                [matTooltip]="tooltipOperador(operador)" (click)="inserirToken(operador)">
                {{ operador.display }}
            </button>
            }

            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeFuncao('@se', 0)" (click)="inserirBlocoSe()"
                matTooltip="Retorna um valor quando a condição é verdadeira e outro quando é falsa">
                @se( )
            </button>
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeFuncao('@soma', 0)" (click)="inserirBlocoSoma()"
                matTooltip="Soma um ou mais valores, inclusive grupos de valores por item">
                @soma( )
            </button>
            <button type="button" class="status-badge chip-button" [ngClass]="classeBadgeFuncao('@rateio', 0)" (click)="inserirBlocoRateio()"
                matTooltip="Distribui um valor do documento proporcionalmente a uma base por item">
                @rateio( )
            </button>
        </div>
        }
    </section>

    <section class="sub-section-container editor-subsection">
        <div class="sub-section-title">
            <mat-icon>rounded_corner</mat-icon>
            <span>Tipo de arredondamento</span>
        </div>
        <div class="arredondamento-row">
            <mat-button-toggle-group
                class="btn-toggle-group"
                [value]="tipoArredondamento"
                (change)="onArredondamentoChange($event.value)">
                <mat-button-toggle [value]="TipoArredondamentoEnum.Arredondar">Arredondar</mat-button-toggle>
                <mat-button-toggle [value]="TipoArredondamentoEnum.Truncar">Truncar</mat-button-toggle>
            </mat-button-toggle-group>

            <div class="casas-decimais-control" aria-label="Casas decimais">                
                <button
                    mat-icon-button
                    type="button"
                    [disabled]="casasDecimais <= 1"
                    (click)="alterarCasasDecimais(-1)"
                    title="Diminuir casas decimais">
                    <mat-icon>remove</mat-icon>
                </button>
                <span class="casas-decimais-label">{{ casasDecimais }}</span>
                <button
                    mat-icon-button
                    type="button"
                    [disabled]="casasDecimais >= 6"
                    (click)="alterarCasasDecimais(1)"
                    title="Aumentar casas decimais">
                    <mat-icon>add</mat-icon>
                </button>
                <span class="casas-decimais-label">casas decimais</span>
            </div>
        </div>
    </section>

    @if (mostrarVigencia) {
    <section class="sub-section-container editor-subsection">
        <div class="sub-section-title">
            <mat-icon>event</mat-icon>
            <span>Vigência</span>
        </div>
        <div class="vigencia-grid">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Vigência início</mat-label>
                <input
                    matInput
                    [matDatepicker]="pickerInicio"
                    [(ngModel)]="vigenciaInicioDate"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [min]="minVigenciaInicio"
                    [max]="vigenciaFimDate"
                    (ngModelChange)="onVigenciaChange('inicio', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onVigenciaBlur($event, 'inicio')">
                <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Vigência fim</mat-label>
                <input
                    matInput
                    [matDatepicker]="pickerFim"
                    [(ngModel)]="vigenciaFimDate"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [min]="vigenciaInicioDate"
                    (ngModelChange)="onVigenciaChange('fim', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onVigenciaBlur($event, 'fim')">
                <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                <mat-datepicker #pickerFim></mat-datepicker>
            </mat-form-field>
        </div>
    </section>
    }
</div>
